import { hexToRgbA } from 'app/util/map';

const colors = {
    blue900: '#233876',
    blue700: '#1A56DB',
    blue: '#1C64F2',
    blue400: '#76A9FA',
    blue300: '#A4CAFE',
    blue200: '#C3DDFD',
    blue100: '#E1EFFE',
    blue050: '#F4F7FE',
    green: '#14BA6D',
    green500: '#0E9F6E',
    yellow: '#FFA803',
    red700: '#C81E1E',
    red600: '#BF322D',
    orange: '#F07722',
    lightOrange: '#FDF4E6',
    red: '#E14640',
    red050: '#FFEEEE',
    red100: '#FDE8E8',
    black: '#111928',
    white: '#FFFFFF',
    charcoal: '#3D3D3C',
    lightYellow: '#FDF6B2',
    caramel: '#8E4B10',
    gray: '#CCCCCC',
    gray050: '#F9FAFB',
    gray100: '#F3F4F6',
    gray200: '#E5E7EB',
    gray300: '#D1D5DB',
    gray400: '#9CA3AF',
    gray500: '#6B7280',
    gray600: '#4B5563',
    gray700: '#374151',
    gray800: '#1F2A37',
    gray900: '#111928',
    placeholders: '#6B7280',
    lightPink: '#FDB4CA',
    darkNavy: '#181c32',
    pageBackgroundColor: '#f5f8fa',
    purpleNav: '#804399',
    purple: '#7239ea',
    lightPurple: '#f8f5ff',
    lightGreen: '#90ee90',
};

const altColors = {
    purple: '#673DE5',
    lightBlue: '#1FBCD1',
    red: '#F52166',
    successButton: '#057A55',
    successBg: '#DEF7EC',
    gray: '#34495E',
    yellow: '#FECB00',
    caramel: colors.caramel,
};

const starRatingColors = {
    1: colors.red,
    2: colors.orange,
    3: colors.yellow,
    4: '#8AB138',
    5: colors.green,
};

const statePopularityColors = [
    hexToRgbA(colors.blue900, 1),
    hexToRgbA(colors.blue900, 0.9),
    hexToRgbA(colors.blue700, 1),
    hexToRgbA(colors.blue, 1),
    hexToRgbA(colors.blue, 0.9),
    hexToRgbA(colors.blue400, 1),
    hexToRgbA(colors.blue300, 1),
    hexToRgbA(colors.blue200, 1),
    hexToRgbA(colors.blue100, 1),
];

const heatmapColors = [
    '#F85F5F',
    '#FDB376',
    '#F4E684',
    '#44DB64',
    '#0FCA7A',
    '#04AC64',
    '#1B8D5C',
];

const heatmapColorsMono = [
    colors.blue900,
    colors.blue700,
    colors.blue,
    colors.blue400,
    colors.blue300,
    colors.blue200,
    colors.blue100,
];

const alertColors = {
    bgDanger: '#FDE8E8',
    textDanger: '#C81E1E',
    bgWarning: '#FDF6B2',
    bgWarningLow: '#fffdef',
    textWarning: '#8E4B10',
    bgInfo: '#E1EFFE',
    textInfo: '#1C64F2',
    bgSuccess: '#E8F8F2',
    textSuccess: altColors.successButton,
};

const palletColors = [
    `${altColors.purple}`,
    `#FECB00`,
    `${altColors.red}`,
    `${altColors.lightBlue}`,
    `#FE9700`,
    `#34495E`,
    `#DB40F4`,
    `#147E80`,
    `#C1392B`,
    `#FDB4CA`,
];
const opacityStrings = ['ff', '99', '66', '11'];

const getPalletColor = (index) => {
    return `${palletColors[index % palletColors.length]}${opacityStrings[Math.floor(index / palletColors.length)]}`;
};

const getNextPalletColor = (color) => {
    let _colorStr = color;
    let _opacityStr = null;
    let _opacityIdx = 0;
    let newIdx = 0;

    if (_colorStr.length !== 7) {
        _colorStr = color.substring(0, 7);
        _opacityStr = color.substring(7, 9);
        _opacityIdx = opacityStrings.indexOf(_opacityStr);
    }
    newIdx = `${_opacityIdx > 0 ? _opacityIdx : ''}${palletColors.indexOf(_colorStr) + 1}`;

    return `${getPalletColor(newIdx)}`;
};

const getTempCheckColor = (tempValue) => {
    if (tempValue < -5.1) {
        return colors.gray;
    } else if (tempValue < -0.1) {
        return altColors.lightBlue;
    } else if (tempValue < 5.1) {
        return colors.green;
    } else if (tempValue < 8.1) {
        return altColors.yellow;
    } else {
        return colors.red;
    }
};

export {
    colors,
    altColors,
    starRatingColors,
    alertColors,
    palletColors,
    statePopularityColors,
    heatmapColors,
    heatmapColorsMono,
    getPalletColor,
    getNextPalletColor,
    getTempCheckColor,
};
